module.exports = __webpack_public_path__ + "static/image/logo-family/logo_cartoon@2x.png?dfd0dc64";